if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.querySelector('[role="dialog"]').addEventListener('pointerup', event => event.stopPropagation());
      this.zoomButton = this.querySelector('[data-croco-zoom]');
      this.zoomButton?.addEventListener('click', () => this.toggleZoom());
      this.querySelector('[data-croco-prev]')?.addEventListener('click', () => this.stepMedia(-1));
      this.querySelector('[data-croco-next]')?.addEventListener('click', () => this.stepMedia(1));
      this.querySelector('[role="document"]').addEventListener('click', event => {
        if (event.target.matches('img.active')) this.toggleZoom();
      });
      this.addEventListener('keydown', event => {
        if (!this.hasAttribute('open') || event.target.matches('input, textarea, select')) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); this.stepMedia(event.key === 'ArrowLeft' ? -1 : 1);
        }
      });
    }
    get mediaItems() { return [...this.querySelector('[role="document"]').children].filter(el => el.hasAttribute('data-media-id')); }
    show(opener) { super.show(opener); this.setActiveMedia(opener.getAttribute('data-media-id')); }
    hide() { this.resetZoom(); super.hide(); }
    resetZoom() {
      this.classList.remove('croco-is-zoomed');
      this.zoomButton?.setAttribute('aria-pressed', 'false');
      this.mediaItems.forEach(img => { if (img.dataset.originalSizes) img.sizes = img.dataset.originalSizes; });
    }
    setActiveMedia(id) {
      this.resetZoom();
      const items = this.mediaItems;
      const active = items.find(el => el.dataset.mediaId === String(id)) || items[0];
      if (!active) return;
      window.pauseAllMedia();
      items.forEach(el => el.classList.toggle('active', el === active));
      const container = this.querySelector('[role="document"]');
      container.scrollTop = 0; container.scrollLeft = 0;
      if (this.zoomButton) this.zoomButton.disabled = active.tagName !== 'IMG';
      this.querySelectorAll('[data-croco-prev], [data-croco-next]').forEach(btn => { btn.disabled = items.length < 2; });
      if (active.tagName === 'DEFERRED-MEDIA') active.loadContent?.();
    }
    stepMedia(direction) {
      const items = this.mediaItems;
      if (!items.length) return;
      const index = items.findIndex(el => el.classList.contains('active'));
      this.setActiveMedia(items[(index + direction + items.length) % items.length].dataset.mediaId);
    }
    toggleZoom() {
      const img = this.mediaItems.find(el => el.classList.contains('active') && el.tagName === 'IMG');
      if (!img) return;
      const zoomed = !this.classList.contains('croco-is-zoomed');
      if (zoomed) {
        const width = Math.ceil(img.getBoundingClientRect().width * 2);
        this.style.setProperty('--croco-zoom-width', `${width}px`);
        if (!img.dataset.originalSizes) img.dataset.originalSizes = img.sizes;
        img.sizes = `${width}px`;
      } else if (img.dataset.originalSizes) img.sizes = img.dataset.originalSizes;
      this.classList.toggle('croco-is-zoomed', zoomed);
      this.zoomButton?.setAttribute('aria-pressed', String(zoomed));
      if (!zoomed) { const container = this.querySelector('[role="document"]'); container.scrollTop = 0; container.scrollLeft = 0; }
    }
  });
}
